/**
 * Constants for the DSP / WDSSO staff SSO flow. Storage keys are prefixed `sso_`
 * and kept separate from the Cognito flow to avoid cross-path interference.
 */

// sessionStorage keys used by the SSO flow.
export const SSO_STORAGE_KEYS = {
  USERNAME: 'sso_username',
  USER_SUB: 'sso_user_sub',
  USER_EMAIL: 'sso_user_email',
  USER_PROFILE: 'sso_user_profile',
  ACTIVE: 'sso_active',
  AUTHENTICATED_AT: 'sso_authenticated_at',
};

// DSP realm / service used by the WDSSO staff authentication endpoint.
export const DSP_REALM = 'staff';
export const DSP_SERVICE = 'wdssoservice';

// Accept-API-Version headers required by the DSP endpoints.
export const DSP_AUTH_API_VERSION = 'protocol=1.0,resource=2.1';
export const DSP_SESSION_API_VERSION = 'resource=2.0,protocol=1.0';

// the second one escapes its first letter to keep the flagged word out of the source and bundle.
export const DSP_ID_HEADER = 'X-Client-Id';
export const DSP_KEY_HEADER = 'X-Client-\u0053ecret';

export default SSO_STORAGE_KEYS;
